<template>
  <div class="mb-0">
    <h2 v-if="!hide_title" class="text-h6 mb-3">Overview</h2>
    <v-row>
      <v-col v-for="(stat, index) in stats" :key="index" cols="12" sm="6" md="" lg="">
        <v-card
          class="pa-6 fill-height"
          elevation="0"
          outlined
          @click="applyFilter(stat)"
          style="cursor: pointer; position: relative"
          :class="isSelected(stat) ? `${stat.color}--text` : ''"
          :style="isSelected(stat) ? 'border-width: 2px; border-color: currentColor' : ''"
        >
          <div
            v-if="loading"
            class="d-flex flex-column align-center justify-center"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.8);
              z-index: 2;
            "
          >
            <v-progress-circular indeterminate :color="stat.color" size="32"></v-progress-circular>
          </div>
          <div class="d-flex flex-column justify-space-between fill-height">
            <div class="d-flex align-center mb-2">
              <div
                class="d-flex align-center justify-center mr-3"
                style="position: relative; width: 40px; height: 40px"
              >
                <div
                  :class="stat.color"
                  class="rounded-lg"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0.15;
                  "
                ></div>
                <v-icon :color="stat.color">{{ stat.icon }}</v-icon>
              </div>
              <div class="text-subtitle-1 grey--text text--darken-1" style="letter-spacing: 1px">
                {{ stat.title }}
              </div>
            </div>
            <div class="d-flex align-baseline">
              <span class="text-h5 font-weight-bold mr-2 grey--text text--darken-3">
                {{ formatNumber(stat.value) }}
              </span>
            </div>
            <v-progress-linear
              :value="100"
              :color="stat.color"
              height="4"
              rounded
              class="mt-3 opacity-50"
            ></v-progress-linear>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'GlobalStats',
    props: {
      hide_title: {
        type: Boolean,
        default: false,
      },
      filter: {
        type: Object,
        default: () => ({}),
      },
      component_name: {
        type: String,
        default: '',
      },
    },
    watch: {
      filter: {
        handler() {
          this.fetchStats()
        },
        deep: true,
      },
    },
    data() {
      return {
        statsData: {
          totalProducts: 0,
          totalMatches: 0,
          totalUnmatchedProducts: 0,
          totalValidatedMatches: 0,
          totalInvalidatedMatches: 0,
        },
        loading: true,
      }
    },
    computed: {
      stats() {
        return [
          {
            title: 'Total Products',
            value: this.statsData.totalProducts,
            color: 'primary',
            icon: 'mdi-package-variant-closed',
            filterValue: '',
          },
          {
            title: 'Matched Products',
            value: this.statsData.totalMatches,
            color: 'info',
            icon: 'mdi-link-variant',
            filterValue: 'Matched',
          },
          {
            title: 'Unmatched Products',
            value: this.statsData.totalUnmatchedProducts,
            color: 'warning',
            icon: 'mdi-link-variant-off',
            filterValue: 'Not Matched',
          },
          {
            title: 'Validated',
            value: this.statsData.totalValidatedMatches,
            color: 'success',
            icon: 'mdi-check-circle-outline',
            filterValue: 'Validated',
          },
          {
            title: 'Not validated',
            value: this.statsData.totalInvalidatedMatches,
            color: 'error',
            icon: 'mdi-close-circle-outline',
            filterValue: 'Not Validated',
          },
        ]
      },
    },
    mounted() {
      this.fetchStats()
    },
    methods: {
      isSelected(stat) {
        if (stat.filterValue === '') return false
        const currentMatched = this.filter && this.filter.matched ? this.filter.matched : ''
        return currentMatched === stat.filterValue
      },
      applyFilter(stat) {
        this.$emit('filter-selected', stat.filterValue)
      },
      async fetchStats() {
        this.loading = true
        try {
          const response = await axios.get('/api/products/globalstatistics', {
            params: {
              account: localStorage.getItem('account_id'),
              updateInterval: localStorage.getItem('updateInterval') || 1,
              user: localStorage.getItem('user_id'),
              component: this.component_name,
              search_filter: JSON.stringify(this.filter),
              match: 1,
            },
          })
          if (response.data) {
            this.statsData = response.data
          }
        } catch (error) {
          console.error('Error fetching global statistics:', error)
        } finally {
          this.loading = false
        }
      },
      formatNumber(num) {
        if (num === undefined || num === null) return 0
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
    },
  }
</script>

<style scoped>
  .opacity-50 {
    opacity: 0.5;
  }
</style>
